import { Suspense } from "react";
import { useSearchParams } from "react-router-dom";
import VehicleDetailsPage from "./VehicleDetails.page";
import VehiclesList from "./VehiclesList.page";

export default function VehicleWrapper() {
	const [searchParams] = useSearchParams();
	const vehicleId = searchParams.get("id") || "";

	return (
		<Suspense fallback={<div>Loading...</div>}>
			{vehicleId ? <VehicleDetailsPage /> : <VehiclesList />}
		</Suspense>
	);
}
